/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetUserCommentsCommentDtoFromJSON, GetUserCommentsCommentDtoToJSON, } from './GetUserCommentsCommentDto.js';
/**
 * Check if a given object implements the GetUserCommentsResult interface.
 */
export function instanceOfGetUserCommentsResult(value) {
    if (!('comments' in value) || value['comments'] === undefined)
        return false;
    return true;
}
export function GetUserCommentsResultFromJSON(json) {
    return GetUserCommentsResultFromJSONTyped(json, false);
}
export function GetUserCommentsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'comments': (json['comments'].map(GetUserCommentsCommentDtoFromJSON)),
    };
}
export function GetUserCommentsResultToJSON(json) {
    return GetUserCommentsResultToJSONTyped(json, false);
}
export function GetUserCommentsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'comments': (value['comments'].map(GetUserCommentsCommentDtoToJSON)),
    };
}
